import { render, staticRenderFns } from "./otp-method.vue?vue&type=template&id=420ff08c"
import script from "./otp-method.vue?vue&type=script&lang=js"
export * from "./otp-method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports